import { gql } from '@apollo/client'

export const FEEDBACK_REPORT_QUERY = gql`
  query feedbackReport($filter: FeedbackReportFilter!) {
    feedbackReport(filter: $filter) {
      mainPeriod {
        legalAdviceSek
        legalAdviceRsv
        aivSek
        aivRsv
        courtRepresentationSek
        courtRepresentationRsv
      }
      comparisionPeriod {
        legalAdviceSek
        legalAdviceRsv
        aivSek
        aivRsv
        courtRepresentationSek
        courtRepresentationRsv
      }
      trend {
        legalAdviceSek
        legalAdviceRsv
        aivSek
        aivRsv
        courtRepresentationSek
        courtRepresentationRsv
      }
      diff {
        legalAdviceSek
        legalAdviceRsv
        aivSek
        aivRsv
        courtRepresentationSek
        courtRepresentationRsv
      }
    }
  }
`
